<div fxLayout="row" fxLayoutAlign="start center">
    <!-- <div id="txt{{id}}" *ngIf="(type!='date') && (type!='boolean') && (type!='yesno') && (type!='currency')" class="label p-4">[{{type}}]({{_value}})</div> -->
    <div id="txt{{id}}" *ngIf="(type!='date') && (type!='boolean') && (type!='yesno') && (type!='currency')" class="label p-4">{{_value}}</div>
    <div id="txt{{id}}" *ngIf="type=='boolean'" class="label p-4">{{_value ? 'Yes':'No'}}</div>
    <div id="txt{{id}}" *ngIf="type=='date'" class="label p-4">{{_value | dateFormat}}</div>
    <div id="txt{{id}}" *ngIf="type=='currency'" class="label p-4">{{_value | currency:'GBP':'symbol':'1.2'}}</div>
    <div id="txt{{id}}" *ngIf="type=='yesno'" class="label p-4">{{getYesNoText()}}</div>
</div>
